class window.Animations
  constructor: ->


  animateElement: (element, index = 1, timeoutDelay = 0, className='animate-element') ->
    setTimeout( ->
      $(element).removeClass(className)
    , timeoutDelay * index)

  animateElementRevert: (element, index = 1, timeoutDelay = 0, className='animate-element') ->
    setTimeout( ->
      $(element).addClass(className)
    , timeoutDelay * index)

  animateNumbers: (container, numbersItem)->
    step = ->
      t = Math.min((Date.now() - this.startTime)/this.duration, 1)
      value = Math.round(this.target - ((1 - this.easing(t)) * this.delta))
      this.element.textContent = value
      if t != 1 && this.target != value
        this.rafId = window.requestAnimationFrame(this.step)

    numbers = numbersItem || container.find('.statistic-number')
    # Start value for animation:
    current = 100
    # Delay of the first .statistic-number block's animation:
    firstNumberDelay = parseFloat($(numbers.get(0)).css('transition-delay')) * 1000 || 0
    # Durationg of the animation:
    duration = 1000 + firstNumberDelay
    numbers.each ->
      delay = parseFloat($(this).css('transition-delay')) * 1000 || 0
      target = $(this).data('target-value') * 1
      hash =
        target: target
        delta: target - current
        # Syncing all animations to the first one:
        duration: duration - delay
        element: this
        # Cubic ease-out timing function:
        easing: (t) -> (--t) * t * t + 1
        startTime: Date.now() + delay
      hash.step = step.bind(hash)
      $(this).text(current)
      hash.rafId = window.requestAnimationFrame(hash.step)



// WEBPACK FOOTER //
// ./assets/javascripts/app/animations.coffee